import DashboardLayout from 'Layouts/DashboardLayout';
import ArchiveProjectsPage from 'Pages/ArchiveProjectsPage';

const ArchiveProjectsContainer = () => {
  return (
    <DashboardLayout>
      <ArchiveProjectsPage />
    </DashboardLayout>
  );
};

export default ArchiveProjectsContainer;
